<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :title="$t('campaigns.edit_campaign')">
        <template v-slot:preview>
         <div class="row">
           <div class="col-md-6">
             <b-form-group label="Kampanya Adı">
               <b-form-input
                   class="form-control form-control-solid"
                   type="text"
                   name="name"
                   v-model="form.name"
                   placeholder="Kampanya Adı"
               ></b-form-input>
             </b-form-group>

             <b-form-group label="Kampanya Sayfası">
               <b-input-group>
                 <b-form-input
                     class="form-control form-control-solid"
                     type="text"
                     name="name"
                     disabled
                     value="/Mesaj-Paylas/napolyon-cmpcampaign-template"
                     placeholder="Kampanya Adı"
                 ></b-form-input>
                 <b-input-group-append>
                   <b-button variant="primary">Kopyala</b-button>
                 </b-input-group-append>
               </b-input-group>
             </b-form-group>

             <b-form-group label="Tanıtım Başlığı">
               <b-form-input
                   class="form-control form-control-solid"
                   type="text"
                   placeholder="Tanıtım Başlığı"
                   v-model="form.promotional_title"
               ></b-form-input>
             </b-form-group>

             <div class="row">
               <div class="col-md-6">
                 <b-form-group
                     label="İlişkili Kampanya"
                 >
                   <b-form-select
                       class="form-control form-control-solid"
                       v-model="form.selected_campaign"
                       :options="campaigns"
                   ></b-form-select>
                 </b-form-group>
               </div>

               <div class="col-md-6">
                 <b-form-group
                     label="Maksimum Katılım Hakkı"
                 >
                   <b-form-select
                       class="form-control form-control-solid"
                       v-model="form.max_participation"
                       :options="max_participations"
                   ></b-form-select>
                 </b-form-group>
               </div>

               <div class="col-md-12">
                 <b-form-group label="Maksimum Katılım SQL">
                   <b-form-textarea
                       class="form-control form-control-solid"
                       placeholder="SQL Kodu"
                       value=""
                       v-model="form.sql_code"
                   ></b-form-textarea>
                 </b-form-group>
               </div>

               <div class="col-md-6">
                 <b-form-checkbox
                     unchecked-value="not_accepted"
                     v-model="form.image"
                 >
                   Resimli?
                 </b-form-checkbox>
               </div>
               <div class="col-md-6">
                 <b-form-checkbox
                     unchecked-value="not_accepted"
                     v-model="form.confirm_required"
                 >
                   Onay Gerekli?
                 </b-form-checkbox>
               </div>

             </div>

           </div>
           <div class="col-md-6">
             <img style="width:100%;border-radius: 8px;" src="http://cdn.napolyon.com/napolyon/profilgorev/PB_kisiselbilgiler_750x330.png" alt="">
             <div class="separator separator-dashed mb-6 mt-6"></div>
             <RichTextArea></RichTextArea>
           </div>
         </div>
        </template>
        <template v-slot:foot>
          <b-button type="submit" variant="primary" class="fa-pull-right"><i class="fa fa-save"></i> {{ $t('general.save') }}</b-button>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import RichTextArea from "@/view/pages/vue-bootstrap/RichTextArea";

export default {
  name: "EditMessageShareCampaign",
  components: { DashboardBox,RichTextArea },
  methods: {  },
  data() {
    return {
      form : {
        name : 'Yeni Yıl 2019',
        promotional_title: 'Örnek Tanıtım Başlığı',
        selected_campaign: 'Caps',
        max_participation: 2,
        sql_code: 'Örnek SQL Kodu * ....',
        image : true,
        confirm_required : true,
      },
      campaigns: [{ text: this.$t('general.select'), value: null } , 'Napolyon CMP Campaign Template', 'Caps', 'Bilgi Yarışması Eylül 2015 Kazananlar', '100.000 Nap Puan Ekim', 'Eşleştirme Eylül Kazananlar', 'Ekim Reeder'],
      max_participations: [{ text: this.$t('general.select'), value: null } , 1,2,3,4,5,6,7,8],
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('menu.campaigns'), route: "MessageShareCampaigns" },
      { title: this.$t('campaigns.edit_campaign') }
    ]);
  },

}
</script>

<style scoped>

</style>
